import { Component } from '@angular/core';
import { Environment } from 'src/environments/environment';

@Component({
  selector: 'app-ex-navbar',
  templateUrl: './ex-navbar.component.html',
  styleUrls: ['./ex-navbar.component.css']
})
export class ExNavbarComponent {
env: any = Environment;
  debug: string = this.env.app.debug;
  title: string = this.env.app.title;
}
